/**
 * 登录测试模式下生成占位会话令牌（浏览器与 Node 20+ 均支持 Web Crypto）。
 */
export function mockSessionToken(): string {
  const bytes = new Uint8Array(12)
  crypto.getRandomValues(bytes)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

/**
 * 将任意邮箱输入规范为可展示的邮箱字符串（无 `@` 时补全域名）。
 *
 * @param raw - 用户输入
 */
export function normalizeTestEmail(raw: string): string {
  const t = raw.trim()
  if (!t) return 'tester@login-test.local'
  if (t.includes('@')) return t
  return `${t}@login-test.local`
}
